import { SwDerivedApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
import { derived, writable } from "svelte/store";
import { getCampaigns } from "../../../api/campaigns";

export const hasModalBeenOpenedStore = writable(false);

export const selectedCampaignIdStore = writable("");

const openCampaignsArgsStore = derived(
  [userStore, hasModalBeenOpenedStore],
  ([$userStore, $hasModalBeenOpenedStore]) => {
    // Prevent API calls if the modal hasn't been opened
    if (!$hasModalBeenOpenedStore) return null;

    const currentUserOnly = !(
      $userStore.kind === "superUser" ||
      ($userStore.isKind === "viewer" && $userStore.isAdmin)
    );
    return [{ openOnly: true, currentUserOnly }];
  },
);

export const openCampaignsStore = SwDerivedApiStore({
  get: getCampaigns,
  argsStore: openCampaignsArgsStore,
  init: () => [],
});

export const campaignOptions = derived(
  openCampaignsStore,
  ($openCampaignsStore) =>
    ($openCampaignsStore || []).map((campaign) => ({
      id: campaign.campaignId,
      label: campaign.campaignName,
      icon: "fa-regular fa-megaphone",
      creatorUserId: campaign.creatorUserId,
    })),
);
